export const LIST_PRODUCTS = "LIST_PRODUCTS";
export const SELECT_PRODUCT = "SELECT_PRODUCT";
export const GET_PRODUCT = "GET_PRODUCT";
